jQuery(document).ready(function(){
    //       var parent_elm = $('#content__customers__subscriptions__cancel');
    //       if($(".rc_title-bar__description p:contains('{rc_cancel_other}')").length){
    //         var rc_desc = $(this);
    //         $('.rc_title-bar__description p').html($('.rc_title-bar__description p').html().replace(/\{rc_cancel_other\}/g,""));
    //         $('.rc_title-bar__description p').append('<iframe width="560" height="315" src="https://www.youtube.com/embed/9Gmy-mAI2Pk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
    //       };
          
          
          function addItemToCart (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id) {
              // now that the cart is empty... 
              data = {
                "quantity": quantity,
                "id": variant_id,
                "properties[shipping_interval_frequency]": shipping_interval_frequency, 
                "properties[shipping_interval_unit_type]": shipping_interval_unit_type,            
                "properties[subscription_id]": subscription_id
              }
              jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function() { 
                  window.location.href = '/cart'; 
                }
              });
              window.location = '/checkout';
    
          }
          function addPPItemToCart (variant_id, quantity, charge_interval_frequency, charge_interval_unit_type, subscription_id) {
              // now that the cart is empty... 
              data = {
                "quantity": quantity,
                "id": variant_id,
                "properties[charge_interval_frequency]": charge_interval_frequency, 
                "properties[charge_interval_unit_type]": charge_interval_unit_type,            
                "properties[subscription_id]": subscription_id
              }
              jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function() { 
                  window.location.href = '/cart'; 
                }
              });
              window.location = '/checkout';
    
          }
          
          
          function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return null;
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
          }
          
          var rc_var = getParameterByName('variant');
          var rc_qty = getParameterByName('qty');
          var rc_intfreq = getParameterByName('intfreq');
          var rc_intunit = getParameterByName('intunit');
          var rc_subid = getParameterByName('subid');
          
          var rc_ch_intfreq = getParameterByName('cintfreq');
          var rc_ch_intunit = getParameterByName('cintunit');
          
          if(rc_qty == null){ rc_qty = 1; }
          if(rc_intfreq == null){ rc_intfreq = 30; }
          if(rc_intunit == null){ rc_intunit = 'Days'; }
          if(rc_ch_intfreq == null){ rc_ch_intfreq = false; }
          if(rc_ch_intunit == null){ rc_ch_intunit = false; }
    
          if(rc_ch_intfreq!=false && rc_ch_intunit!=false){
            addPPItemToCart(rc_var, rc_qty, rc_ch_intfreq, rc_ch_intunit, rc_subid);
          }
          else if(rc_var && rc_qty && rc_intfreq && rc_intunit && rc_subid){
            addItemToCart(rc_var, rc_qty, rc_intfreq, rc_intunit, rc_subid);
          }
    
          $('.rc-add-to-cart').click(function(){
            var rc_click = $(this),
                rc_var = rc_click.data('variant'),
                rc_qty = rc_click.data('qty'),
                rc_intfreq = rc_click.data('intfreq'),
                rc_intunit = rc_click.data('intunit'),
                rc_subid = rc_click.data('subid');
    
            if(rc_qty == null || rc_qty == ''){ rc_qty = 1; }
            if(rc_intfreq == null || rc_intfreq == ''){ rc_intfreq = 30; }
            if(rc_intunit == null || rc_intunit == ''){ rc_intunit = 'Days'; }
    
            if(rc_var && rc_qty && rc_intfreq && rc_intunit && rc_subid){
              addItemToCart(rc_var, rc_qty, rc_intfreq, rc_intunit, rc_subid);
            }
          })
    });